__webpack_require__.p = "https://stg.treatyourself-ks.com/";